<header class="header">
  <h3>
    {{ 'MICROSOFT-ONLINE.END_EDITING_DIALOG.HEADER' | translate }}
  </h3>
  <span mat-dialog-close class="wk-icon-close"></span>
</header>

<section mat-dialog-content>
  <p class="text-description">
    {{ 'MICROSOFT-ONLINE.END_EDITING_DIALOG.DESCRIPTION' | translate }}
  </p>

  <div id="version-details">
    <p class="text-description">
      {{ 'MICROSOFT-ONLINE.END_EDITING_DIALOG.CHANGES' | translate }}
    </p>

    <div class="user-input">
      <div class="wk-field docs-checkbox-radio">
        <div class="wk-field-body">
          <label class="wk-field-choice-label">
            <input
              type="radio"
              value="minor"
              class="wk-field-choice"
              [checked]="version === 'minor'"
              (change)="version = $event.target['value']"
            />
            <span class="wk-field-choice-text">{{
              'MICROSOFT-ONLINE.END_EDITING_DIALOG.MINOR_VERSION' | translate
            }}</span>
          </label>
          <label class="wk-field-choice-label">
            <input
              type="radio"
              name="default-1"
              value="major"
              class="wk-field-choice"
              [checked]="version === 'major'"
              (change)="version = $event.target['value']"
            />
            <span class="wk-field-choice-text">{{
              'MICROSOFT-ONLINE.END_EDITING_DIALOG.MAJOR_VERSION' | translate
            }}</span>
          </label>
        </div>
      </div>
      <div class="wk-field wk-field-secondary">
        <div class="wk-field-body">
          <input
            type="text"
            id="version-comment"
            placeholder="{{
              'MICROSOFT-ONLINE.END_EDITING_DIALOG.COMMENT_PLACEHOLDER'
                | translate
            }}"
            class="wk-field-input"
            [(ngModel)]="comment"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<div class="actions">
  <button
    class="wk-button wk-button-text"
    mat-dialog-close
    id="adw-end-dialog-button"
  >
    {{ 'MICROSOFT-ONLINE.END_EDITING_DIALOG.CANCEL' | translate }}
  </button>
  <button class="wk-button wk-button-ghost" (click)="discardSession()">
    {{ 'MICROSOFT-ONLINE.END_EDITING_DIALOG.DISCARD' | translate }}
  </button>
  <button
    class="wk-button"
    id="adw-submit-dialog-button"
    (click)="endSession()"
  >
    {{ 'MICROSOFT-ONLINE.END_EDITING_DIALOG.END' | translate }}
  </button>
</div>
